// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DeleteFilledSvg from "@fishx/icons-svg/es/asn/DeleteFilled";
import FishxIcon from '../components/FishxIcon';

var DeleteFilled = function DeleteFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DeleteFilledSvg
  }));
};

DeleteFilled.displayName = 'DeleteFilled';
export default React.forwardRef(DeleteFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DeleteFilled.js
// module id = 2392
// module chunks = 0